import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { Partner } from '@app/partners/model/partner.model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-partner-basic',
    templateUrl: './partner-basic.component.html',
    styleUrls: ['./partner-basic.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe],
})
export class PartnerBasicComponent {
    @Input({ required: true }) partner!: Partner;
}
